
import {getUser_role_menus} from "@/api/roleModel/roleApi";
import {showTip,getSessionData,setSessionData,setRouteMenuData} from "@/utils/commonApi";
import store from "@/store";
const user = {
  state: {
    // loginUserInfo: sessionGet("loginUserInfo") || {},
    // workerObj: sessionGet(getSessionKey()) || {},
    // token: hasToken() ? getToken() : "",
    permissions: ["demo:add", "demo:edit", "demo:delete"],
  },

  mutations: {
    // SET_LOGIN_USER_INFO: (state, token) => {
    //   state.token = token;
    // },
    SET_PERMISSIONS: (state, userData) => {
      state.permissions = userData;
    },
  },

  actions: {
    // 获取用户信息
    GetUserInfo({ commit, state },routeData) {
      return new Promise((resolve, reject) => {
        if(!getSessionData("menuInfo")){
          getUser_role_menus({role_id:getSessionData("roleData").role_id}).then((res) => {
            if (res.code == "SUCCESS") {
              // store.dispatch('setUserPermission',routeData);
              // commit("SET_PERMISSIONS", res.data.menu.operation_list.map(item => item.code));
              // setSessionData("userInfo",JSON.stringify(res.data))
              res.data.menu.menu_list.unshift( {
                "id": "210631910980845568",
                "code": "indexPage",
                "name": "首页概览",
                "route": "/indexPage",
                "description": "首页概览",
                // "icon":'indexPage',
                "menu_list": [],
                "operation_list": []
              })
              resolve(res.data);
            }
          })
              .catch((error) => {
                reject(error);
              });
        }else{
          resolve(getSessionData("loginUserInfo"))
        }
      });
    },
    //权限
    setUserPermission({ commit, state },routeData) {
      let menuList = getSessionData("menuInfo");
      if(!menuList){
        return
      }
      let routePathArr = routeData.path.split("/");
      let routePath = routePathArr[routePathArr.length-1];
      // console.log(routePath)
      // console.log(menuList);
      // console.log(routeData);
      getPreData(menuList.menu_list)
      function getPreData(menuData) {
        for (var i = 0;i<menuData.length;i++){
          if(menuData[i].code == routePath){
            // console.log(menuData[i])
            setRouteMenuData(menuData[i])
            console.log(routePath + "页面权限" + '------' + menuData[i].operation_list.map(item => item.code) + menuData[i].operation_list.map(item => item.name))
            commit("SET_PERMISSIONS", menuData[i].operation_list.map(item => item.code));
            return false;
          }else{
            getPreData(menuData[i].menu_list)
          }
        }
      }

      // commit("SET_PERMISSIONS", routeData);
    },
  },
};

export default user;
